export class Error {
  errorMessage: string;
  errorDetails: string;
  errorStackTrace: string;
}
